/** @format */

import { Component, Input, OnInit } from '@angular/core';

import { DCSG_CONSTANTS } from '@shared/data-access/constants';
import { TaggingService } from '@shared/data-access/services';

@Component({
	selector: 'shared-media-component-homr-asset',
	templateUrl: './media-homr-asset.component.html',
	providers: [],
	standalone: false
})
export class MediaHomrAssetComponent implements OnInit {
	@Input() visualAssets: any[];
	@Input() itemTitle: string;
	@Input() imageWidthParam = DCSG_CONSTANTS.maxAppWidth;
	@Input() altText: string;
	@Input() willLazyLoad: boolean;
	@Input() prioritize = false;

	public altTagService: any;

	public image: any;
	public mobileImage: any;
	public animation: any;

	constructor(private taggingService: TaggingService) {
		this.altTagService = this.taggingService.altTag;
	}

	ngOnInit() {
		// eslint-disable-next-line @typescript-eslint/no-unused-vars
		const { length, ...va } = this.visualAssets[0];

		for (const a in Object.values(va)) {
			if (Object.values(va)[a]) {
				const asset: any = Object.values(va)[a];
				switch (asset.type) {
					case 'imageUpload':
						this.image = asset;
						break;
					case 'mobileImageUpload':
						this.mobileImage = asset;
						break;
					case 'animationUpload':
						this.animation = asset;
						break;
				}
			}
		}
	}
}
